import { render, staticRenderFns } from "./zcm.vue?vue&type=template&id=1b08e74f&scoped=true&"
var script = {}
import style0 from "./zcm.vue?vue&type=style&index=0&id=1b08e74f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b08e74f",
  null
  
)

export default component.exports